"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SDK_VERSION = void 0;
// __SDK_VERSION__会被打包替换为 package.json 中的 version 值
var SDK_VERSION = '__SDK_VERSION__';
exports.SDK_VERSION = SDK_VERSION;